module.exports = __webpack_public_path__ + "img/im.dd0fdaa.svg";